import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import React from "react";
import { useFragment } from "react-relay";

import { VStack } from "@whoosh/design-system/src/components/primitive";

import { FormStepHeader } from "../FormStepHeader";
import { PrimaryChargeSelectionStep_event$key } from "./__generated__/PrimaryChargeSelectionStep_event.graphql";
import { PerGroupSelection } from "./components/PerGroupSelection";
import { PerPersonSelectionList } from "./components/PerPersonSelectionList";
import { useGetAllPrimaryChargeSelectionOptions } from "./hooks/useGetAllPrimaryChargeSelectionOptions";

type PrimaryChargeSelectionStepProps = {
  eventRef: PrimaryChargeSelectionStep_event$key;
};

export const PrimaryChargeSelectionStep = ({
  eventRef,
}: PrimaryChargeSelectionStepProps) => {
  const data = useFragment(PrimaryChargeSelectionStepFragmentString, eventRef);
  const isSelectionPerPerson = data.primaryChargeType === "PER_PERSON";
  const options = useGetAllPrimaryChargeSelectionOptions({ eventRef: data });

  return (
    <VStack flex={1} testID="primary-charge-selection-step">
      <FormStepHeader title={t`Select Primary Charges`} />
      {isSelectionPerPerson ? (
        <PerPersonSelectionList eventId={data.id} fallbackOptions={options} />
      ) : (
        <PerGroupSelection options={options} />
      )}
    </VStack>
  );
};

const PrimaryChargeSelectionStepFragmentString = graphql`
  fragment PrimaryChargeSelectionStep_event on Event {
    id
    ...useGetAllPrimaryChargeSelectionOptions_event
    primaryChargeType
    prePaymentRequirement
  }
`;
